import { render } from "./RefGetter.vue?vue&type=template&id=7abbbfad&scoped=true"
import script from "./RefGetter.vue?vue&type=script&lang=js"
export * from "./RefGetter.vue?vue&type=script&lang=js"

import "./RefGetter.vue?vue&type=style&index=0&id=7abbbfad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abbbfad"]])

export default __exports__